import { formatHour } from "../../../utils/helper";
import { DescriptionContainer, StyledTypography, Column} from "./style";

import {t} from 'i18next';
import { ITalksProps } from "../../../interfaces/university/talk";


type props = {
  object: ITalksProps;
}

export const TalkDescription = ({object}: props) => {
  return (
    <DescriptionContainer>
      <Column className="description-column">
          <StyledTypography color='label' type='subheading3'>{t('description').toUpperCase()}</StyledTypography>
          <StyledTypography color='title' type='body3'>{object.description}</StyledTypography>
        </Column>
        <Column>
          <StyledTypography color='label' type='subheading3'>{t('topic').toUpperCase()}</StyledTypography>
          <StyledTypography color='title' type='body3'>{object.category}</StyledTypography>
        </Column>
        <Column>
          <StyledTypography color='label' type='subheading3'>{t('duration').toUpperCase()}</StyledTypography>
          <StyledTypography color='title' type='body3'>{formatHour(object.estimated_duration)}</StyledTypography>
        </Column>
    </DescriptionContainer>
  );
}